<pk-upload *ngIf="!routeData.componentInput.isUrl; else url" [categories]="categories$ | async" (uploaded)="filesUploaded($event)"></pk-upload>
<ng-template #url>
  <pk-upload-url [categories]="categories$ | async" (uploaded)="filesUploaded($event)"></pk-upload-url>
</ng-template>
